import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  controlLabelRoot: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.gray.lightShade,
    borderRadius: 8,
    padding: theme.spacing(0.75),
    paddingRight: theme.spacing(2),
    margin: 0,
  },
  soundWaves: {
    position: "absolute",
    left: -5,
    top: 2,
    scale: 0.7,
  },
}));
